import { createCommandPage, settings } from "@ceyper-common";
import { COMMANDS } from "$lib/commands/commands";
import { VERSION } from "$generated/version";

const {
    createSettings,
    createSettingsPage,

    action,
    boolean,
    columns,
    columnsGroup,
    group,
    number,
    page,
    select,
    text,
    color,
    validate,
} = settings;

/// ///////////////////////////////////////////////////// ///
/// General settings                                      ///
/// ///////////////////////////////////////////////////// ///
export const GeneralSettings = createSettings({
    username: text("Username", "Name"),
    "ui-scale": number("UI Scale", 100, 25, 1000, 25),
});
const GeneralSettingsPage = page(GeneralSettings, "General", [
    group("User", ["username"]),
    group("Interface", ["ui-scale"]),
]);

/// ///////////////////////////////////////////////////// ///
/// Editor settings                                       ///
/// ///////////////////////////////////////////////////// ///
export const EditorSettings = createSettings({
    "lock-palette": boolean("Lock Palette", false),
    "shadow-before-steps": number("Steps", 1, 0, 9, 1),
    "shadow-before-filter": text("Filter", "opacity(pow(0.5, var(--i))))"),
    "shadow-after-steps": number("Steps", 0, 0, 9, 1),
    "shadow-after-filter": text("Filter", "opacity(pow(0.5, var(--i))))"),

    "grid-visible": boolean("Grid visible", false),
    "grid-visible-at-zoom": number("Grid visible at zoom level", 4, 0, 64, 1),

    "canvas-background": color("Canvas background", "#121212"),
});
const EditorSettingsPage = page(EditorSettings, "Editor", [
    group("General", ["lock-palette", "canvas-background"]),
    // group("Animation", [
    //     columnsGroup("Frame shadow", [
    //         [group("Before", ["shadow-before-steps", "shadow-before-filter"])],
    //         [group("After", ["shadow-after-steps", "shadow-after-filter"])],
    //     ]),
    // ]),
    group("Pixel grid", ["grid-visible", "grid-visible-at-zoom"]),
]);

/// ///////////////////////////////////////////////////// ///
/// File settings                                         ///
/// ///////////////////////////////////////////////////// ///
export const FileSettings = createSettings({
    "file.auto-save": boolean("Auto save enabled", true),
    // "file.auto-save-interval": number("Auto save interval", 5, 1),

    "file.export-scale": number("Scale", 1, 1, 1024, 1),
    "file.export-download-all": boolean("Download all frames (as .zip)", true),
});
const FileSettingsPage = page(FileSettings, "File", [
    group("Auto save", [
        "file.auto-save",
        // "file.auto-save-interval",
    ]),
    group("Export options", ["file.export-scale", "file.export-download-all"]),
]);

export const SETTINGS_PAGES = createSettingsPage(
    [GeneralSettingsPage, FileSettingsPage, EditorSettingsPage, createCommandPage(COMMANDS)],
    VERSION.commit.substring(0, 8)
);
